const INPUT_TAG_RX = /^(?:input|select|textarea)$/i;

export default function isInput(target) {
  return target && INPUT_TAG_RX.test(target.tagName);
}
